export default class {
  constructor(element) {
    this.element = element;
    this.setupEventListeners();
  }

  showSuccess() {
    this.element.classList.add('is-visible');
    this.element.classList.add('is-success');
  }

  showError() {
    this.element.classList.add('is-visible');
  }

  hide() {
    this.element.classList.remove('is-visible');
    this.element.classList.remove('is-success');
  }

  setupEventListeners() {
    this.element.querySelector(".callback-close-button").addEventListener("click", () => {
      this.hide();
    })
    this.element.addEventListener("click", () => {
      this.hide();
    })
  }
}
